module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei2.svg";